const hideFromWebPlayVisibilityRule = { check: (node, actionCardData) => !node.hideFromWebPlay }

export default function* getNodesVisibilityRules() {
  yield hideFromWebPlayVisibilityRule
}
